import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MovieService } from '../services/movie.service';

interface Movie {
  name: string;
  url: string;
}
@Component({
  selector: 'app-movie',
  templateUrl: './movie.component.html',
  styleUrls: ['./movie.component.scss']
})
export class MovieComponent implements OnInit {

  public movies: any;
  public isDarkMode: boolean;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private moviesServ: MovieService) { }

  ngOnInit(): void {
    const pathId = this.activatedRoute.snapshot.paramMap.get('id');
    this.moviesServ.getMovie(pathId).subscribe((movies) => {
      const compare = (a: any, b: any) => {
        console.log(a.episode);
        if (a.episode < b.episode) {
          return -1;
        }
        if (a.episode > b.episode) {
          return 1;
        }
        return 0;
      };

      if (!movies.length) {
        this.router.navigate(['/']);
      }

      this.movies = movies.sort(compare);
      console.log(this.movies);
    });
  }

  changeTheme() {
    this.isDarkMode = !this.isDarkMode;
  }

  downloadMovie(movie: Movie) {
    window.location.assign(movie.url);
  }

}
